<template>
  <!--
    	作者：luoyiming
    	时间：2020-06-20
    	描述：diy组件-参数设置-登录按钮组件
    -->
  <div>
    <div class="common-form"><span>{{ curItem.name }}</span></div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!--背景颜色-->
      <el-form-item :label="$t('背景颜色')">
        <div class="d-s-c">
          <el-color-picker v-model="curItem.style.background"></el-color-picker>
          <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')">
           {{$t('重置')}} 
          </el-button>
        </div>
      </el-form-item>
      <el-form-item :label="$t('标题')">
        <div class="param-img-item" :key="index" v-for="(login, index) in curItem.data">
          <div class="url-box">
            <span class="key-name">{{$t('标题')}}</span>
            <el-input v-model="login.title"></el-input>
          </div>
          <div class="url-box">
            <span class="key-name">{{$t('文字内容')}}</span>
            <el-input v-model="login.text"></el-input>
          </div>
          <div class="url-box">
            <span class="key-name">{{$t('颜色')}}</span>
            <div class="d-s-c">
              <el-color-picker v-model="login.color"></el-color-picker>
              <el-button type="button" style="margin-left: 10px;" @click.stop="$parent.onEditorResetColor(curItem.style, 'btnColor', '#ffffff')">
                {{$t('重置')}}
              </el-button>
            </div>
          </div>
          <div class="d-s-c">
            <div class="url-box flex-1">
              <span class="key-name">{{$t('链接名称')}}</span>
              <el-input v-model="login.name"></el-input>
            </div>
            <div class="url-box ml10">
              <el-button type="primary" @click="changeLink(index)">{{$t('选择链接')}}</el-button>
            </div>
          </div>
        </div>
        <div class="d-c-c" v-if="curItem.data.length==1&&curItem.style.rowsNum==2">
          <el-button @click="$parent.onEditorAddData">{{$t('添加一个')}}</el-button>
        </div>
      </el-form-item>
    </el-form>
    <Setlink v-if="is_linkset" :is_linkset="is_linkset" @closeDialog="closeLinkset">{{$t('选择链接')}}</Setlink>
  </div>
</template>

<script>
import Setlink from '@/components/setlink/Setlink';
export default {
  components: {
    Setlink,
  },
  data() {
    return {
      /*是否选择链接*/
      is_linkset: false,
      index: null,
    };
  },
  props: ['curItem', 'selectedIndex', 'opts'],
  methods: {

    /*选择链接*/
    changeLink(index) {
      this.is_linkset = true;
      this.index = index;
    },

    /*获取链接并关闭弹窗*/
    closeLinkset(e) {
      this.is_linkset = false;
      this.curItem.data[this.index].linkUrl=e.url;
      this.curItem.data[this.index].name =  this.$t('链接到') + ' ' + e.type + ' ' + e.name;
    },
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/buildStore/website/homePageEdit/params/Login.vue